<template>
  <ProductShowcase
    v-if="similarOnlineEvents?.length"
    :gtm-item-list-id="GtmItemListId.EventPageSimilarOnlineClasses"
    class="my-20"
    data-test-id="online-events"
    :loading="pending"
    :products="similarOnlineEvents"
    :tags="[]"
    :title="t('product.similarOnlineEvents')"
    :title-level="2"
    :use-h-tag="true"
    :algolia-insights-client="insightsClient"
    algolia-insights-label="Similar Online Events - Event Page"
  />
</template>
<script setup lang="ts">
import { GtmItemListId } from '~/composables/useKftGtm/types'
import type { EventDescription } from '~/composables/types/event'

const eventData = inject<EventDescription>('eventData')
const { client: insightsClient } = useAlgoliaSearchInsights()

const { t } = useI18n()

const { data: similarOnlineEvents, pending } = useFetchSimilarOnlineEvents(
  eventGetters.getMainCategorySlug(eventData)!,
  {
    server: false,
    transform: transformToAlgoliaEvent,
    default: () => [],
  }
)
</script>
